// Nombre que el operador ve de cada momento de mensaje, por su id de ficha (`PM-001`). Lo usan la
// pantalla Mensajes a cliente y la pestaña Mensajes de los cajones.

export const MOMENT_NAMES: Readonly<Partial<Record<string, string>>> = {
    'PM-001': 'Solicitud aprobada',
    'PM-002': 'Solicitud rechazada',
    'PM-003': 'Enganche recibido',
    'PM-004': 'Contrato firmado · Bienvenida',
    'PM-005': 'Activación MDM',
    'PM-010': 'Recordatorio T-3',
    'PM-011': 'Recordatorio T-2',
    'PM-012': 'Recordatorio T-1',
    'PM-020': 'Pago aplicado',
    'PM-021': 'Pago parcial recibido',
    'PM-022': 'Pago rechazado',
    'PM-023': 'Pago adelantado',
    'PM-030': 'Vencida ayer (T+1)',
    'PM-031': 'Sigue vencida (T+3)',
    'PM-032': 'Pre-bloqueo (T+5)',
    'PM-033': 'Mora escalada (T+15)',
    'PM-034': 'Aviso reporte buró (T+60)',
    'PM-040': 'Bloqueo MDM aplicado',
    'PM-041': 'MDM liberado',
    'PM-050': 'F1 · Reestructura propuesta',
    'PM-051': 'F1 · Reestructura aprobada',
    'PM-052': 'F2 · Cancelación procesada',
    'PM-053': 'F3 · Descuento aplicado',
    'PM-054': 'F4 · Corrección aplicada',
    'PM-055': 'F5 · Fraude confirmado',
    'PM-056': 'Compromiso de pago registrado',
    'PM-057': 'Compromiso incumplido',
    'PM-060': 'Última cuota',
    'PM-061': 'Liquidación exitosa',
    'PM-062': 'Aviso liquidación al buró',
    'PM-063': 'Invitación reingreso',
    'PM-070': 'Bienvenida a la app',
    'PM-071': 'Código OTP',
    'PM-072': 'Alerta de seguridad',
    'PM-073': 'Cambio de datos confirmado',
    'PM-074': 'Estado de cuenta mensual',
    'PM-075': 'Aviso CAT / cambio TyC',
    'PM-076': 'Aviso privacidad ARCO',
    'PM-080': 'Premio de referido abonado',
    'PM-081': 'Aquí está tu código',
};

/** Nombre del momento; un id sin nombre se ve tal cual. */
export function momentNameOf(templateId: string): string {
    return MOMENT_NAMES[templateId] ?? templateId;
}
